import { ModusWcTypography } from '@trimble-oss/moduswebcomponents-react';
import React, { PropsWithChildren } from 'react';
import './Typography.scss';

export type TypographyHierarchy = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p';
export type TypographySize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';
export type TypographyWeight = 'light' | 'normal' | 'semibold' | 'bold';

export interface TypographyProps extends React.ComponentProps<typeof ModusWcTypography> {
  hierarchy?: TypographyHierarchy;
  size?: TypographySize;
  weight?: TypographyWeight;
  sx?: React.CSSProperties;
  variant?: 'default' | 'inherit';
  label?: string;
}

export const Typography: React.FC<PropsWithChildren<TypographyProps>> = ({
  children,
  variant = 'default',
  ...props
}) => {
  return <ModusWcTypography {...props}>{children}</ModusWcTypography>;
};
